var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostImpact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    width: 16,
    height: 6,
    rx: 3,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 37,
    width: 16,
    height: 6,
    rx: 3,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 16,
    height: 6,
    rx: 3,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 21.6916C24.2499 14.1916 11.4999 14.1912 7.99994 21.6912C6.79184 24.28 5.22631 27.8666 3.69404 31.4538C0.659844 38.5571 4.85125 46.7283 12.509 47.7393C14.575 48.0121 16.5027 48.1914 17.9999 48.1914",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25.8581C15.2386 25.8581 13 27.3504 13 29.1914C13 31.0323 15.2386 32.5247 18 32.5247C20.7614 32.5247 23 34.0171 23 35.858C23 37.699 20.7614 39.1914 18 39.1914M18 25.8581C19.8507 25.8581 21.4665 26.5284 22.3311 27.5247M18 25.8581V24.1914M18 25.8581L18 39.1914M18 39.1914L18 40.858M18 39.1914C16.1493 39.1913 14.5335 38.521 13.6689 37.5247",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61614 17.5764L5.5475 14.3145C5.06189 13.9252 5.05576 13.2051 5.57062 12.8554C7.39562 11.6158 11.7608 9.19272 18 9.19272C24.2528 9.19272 28.8271 11.6263 30.7485 12.8635C31.281 13.2063 31.2902 13.9427 30.7994 14.3428L26.3838 17.9427",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostImpact);
export default __webpack_public_path__ + "static/media/costImpact.0dc57ac1a557b8f0e2c650c64f81dce2.svg";
export { ForwardRef as ReactComponent };